module.exports = __webpack_public_path__ + "static/img/pinkHead.1af2cc65.png";